import React, { useState, useEffect } from "react";

function CardTextNumber(props) {
  //props
  const { text_title, text_number } = props;

  return (
    <React.Fragment>
      <div className="div_counter">
        <font className="font_counter_title">{text_title}</font>
        <br />
        <font className="font_counter_number">{text_number}</font>
      </div>
    </React.Fragment>
  );
}

export default CardTextNumber;
